import {
  ActionContext,
  ActionTree,
  GetterTree,
  Module,
  MutationTree
} from "vuex";
import pillUseCases from "../../../../domain/usecase/impl/pill/pillUseCases";

import { Pill, PillList } from "../../../../domain/entities/pill";
import { RootState } from "../store";

class PillState {
  pill: Pill = new Pill();
  pills: Pill[] = [];
  pillList: PillList = new PillList();
  numberOfPages = 0;
}

const state = new PillState();

const mutations: MutationTree<PillState> = {
  SET_PILL(state: PillState, pill: Pill): void {
    state.pill = pill;
  },
  SET_PILLS(state, payload: { list: PillList; index: number }) {
    const { list, index } = payload;

    if (index === 0) {
      state.pillList = list;
    } else {
      state.pillList.pills.push(...list.pills);
      state.pillList.has_more = list.has_more;
    }
  },
  RESET_PILLS(state, list: PillList) {
    state.pillList = list;
  },
};

const actions: ActionTree<PillState, PillState> = {
  /** Lists an array with all the pills in the app. */
  async list(
    { commit },
    payload: { index: number }
  ): Promise<void> {
    try {
      const list: PillList = await pillUseCases.list(payload.index);

      commit("SET_PILLS", { list, index: payload.index });
    } catch (e) {
      console.log(e);
      throw e;
    }
  },

  /** Gets a pill.
   * @param commit
   * @param id ID of the pill. */
  async get(
    { commit }: ActionContext<PillState, PillState>,
    id: number
  ): Promise<void> {
    try {
      const response: Pill = await pillUseCases.get(id);
      commit("SET_PILL", response);
    } catch (e) {
      commit("SET_PILL", new Pill());
      console.log(e);
      throw e;
    }
  },

  async watch(
    { commit }: ActionContext<PillState, PillState>,
    id: number
  ): Promise<void> {
    try {
      return await pillUseCases.watch(id);
    } catch (e) {
      console.log(e);
      throw e;
    }
  }
};

const getters: GetterTree<PillState, PillState> = {
  pill: (state: PillState): Pill => state.pill,
  pillList: (state: PillState): PillList => state.pillList
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
} as Module<PillState, PillState>;
